import primary from './primary';
import secondary from './secondary';
import transparentWhite from './transparent-white';
import white from './white';
import icon from './icon';
import primaryIcon from './primary-icon';
import transparent from './transparent';

export default {
  primary,
  secondary,
  white,
  'transparent-white': transparentWhite,
  icon,
  'primary-icon': primaryIcon,
  transparent
};
